<section class="contact">
  <div class="form-container">
    <div class="contact-txt">
      <h1 class="header-txt">{{ "contact.headline" | translate }}</h1>
    </div>
    <div class="info-side mobile">
      <p class="lead">{{ "contact.info.lead" | translate }}</p>
      <p class="muted">{{ "contact.info.muted" | translate }}</p>
      <ul class="contacts">
        <li>
          <div class="email-container">
            <img
              class="emailImg"
              src="assets/img/icons/contact/eMail_contact.svg"
              alt="E-Mail Icon"
            />
            <a class="emailLink" href="mailto:ebubekir.elicora@gmx.de"
              >E-Mail: ebubekir.elicora&#64;gmx.de</a
            >
          </div>
        </li>
        <li>
          <div class="phone-container">
            <img
              class="phoneImg"
              src="assets/img/icons/contact/phone_contact.svg"
              alt="Telefon Icon"
            />
            <a class="phoneLink" href="tel:+491714155340">Tel: 0171 4155340 </a>
          </div>
        </li>
      </ul>
    </div>
    <div class="form-side">
      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
        <div class="input-wrapper" [class.has-error]="showNameError()">
          <input
            #nameInput
            formControlName="name"
            [placeholder]="
              showNameError() ? '' : ('contact.form.name' | translate)
            "
            (focus)="onNameFocus()"
            (blur)="onNameBlur()"
          />
          <img
            class="input-icon"
            src="assets/img/icons/contact/done.svg"
            alt=""
            *ngIf="isFieldValid(nameCtrl)"
          />
          <div
            class="field-error"
            *ngIf="showNameError()"
            (click)="focusNameInput()"
          >
            <span class="field-error__text">{{ nameErrorText() }}</span>
            <img
              class="field-error__icon"
              src="assets/img/icons/contact/error.svg"
              alt=""
            />
          </div>
        </div>
        <div class="input-wrapper" [class.has-error]="showEmailError()">
          <input
            #emailInput
            type="email"
            formControlName="email"
            [placeholder]="
              showEmailError() ? '' : ('contact.form.email' | translate)
            "
            (focus)="onEmailFocus()"
            (blur)="onEmailBlur()"
          />
          <img
            class="input-icon"
            src="assets/img/icons/contact/done.svg"
            alt=""
            *ngIf="isFieldValid(emailCtrl)"
          />
          <div
            class="field-error"
            *ngIf="showEmailError()"
            (click)="focusEmailInput()"
          >
            <span class="field-error__text">{{ emailErrorText() }}</span>
            <img
              class="field-error__icon"
              src="assets/img/icons/contact/error.svg"
              alt=""
            />
          </div>
        </div>
        <div
          class="input-wrapper textarea-wrapper"
          [class.has-error]="showMessageError()"
        >
          <textarea
            formControlName="message"
            rows="11"
            [placeholder]="
              showMessageError() ? '' : ('contact.form.message' | translate)
            "
            (focus)="onMessageFocus()"
            (blur)="onMessageBlur()"
          ></textarea>
          <img
            class="input-icon done-message"
            src="assets/img/icons/contact/done.svg"
            alt=""
            *ngIf="isFieldValid(messageCtrl)"
          />
          <div class="textarea-error" *ngIf="showMessageError()">
            <span class="field-error__text">{{ messageErrorText() }}</span>
            <img
              class="field-error__icon"
              src="assets/img/icons/contact/error.svg"
              alt=""
            />
          </div>
        </div>
        <div class="checkbox-btn-container">
          <div class="container-size">
            <div class="policy" [class.policy-error]="showPrivacyError()">
              <input
                type="checkbox"
                formControlName="privacy"
                [class.privacy-error]="showPrivacyError()"
              />
              <span class="policy-text">
                {{ "contact.form.policy_prefix" | translate }}
                <a routerLink="/privacy">
                  {{ "contact.form.policy_link" | translate }}
                </a>
                {{ "contact.form.policy_suffix" | translate }}
                <p class="privacy-error-text" *ngIf="showPrivacyError()">
                  {{ "contact.errors.privacy_required" | translate }}
                </p>
              </span>
            </div>
            <div class="btn-pos">
              <button
                type="submit"
                [ngClass]="{
                  btn: contactForm.valid && contactForm.get('privacy')?.value,
                  'btn-sub': !(
                    contactForm.valid && contactForm.get('privacy')?.value
                  )
                }"
                [disabled]="submitting"
              >
                {{ "contact.form.send" | translate }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="social-container mobile-arrow">
    <img
      class="next-arrow-mobile"
      src="assets/img/icons/arrows/arrow_left.png"
      alt="Zurück"
      role="button"
      tabindex="0"
      (click)="onBack()"
      (keydown.enter)="onBack()"
      (keydown.space)="onBack()"
    />
  </div>

  <nav class="mobile-social" aria-label="social">
    <div class="top-links">
      <a
        href="https://github.com/EbubekirElicora"
        target="_blank"
        rel="noopener"
        aria-label="GitHub"
        class="icon"
      >
        <img
          class="base"
          src="assets/img/icons/social_media/gitHub.svg"
          alt="GitHub"
        />
        <img
          class="hover"
          src="assets/img/icons/social_media/gitHub_hover.svg"
          alt=""
          aria-hidden="true"
        />
      </a>
      <a href="mailto:ebubekir.elicora@gmx.de" aria-label="E-Mail" class="icon">
        <img
          class="base"
          src="assets/img/icons/social_media/eMail.svg"
          alt="Mail"
        />
        <img
          class="hover"
          src="assets/img/icons/social_media/eMail_hover.svg"
          alt=""
          aria-hidden="true"
        />
      </a>
      <a
        href="https://www.linkedin.com/in/ebubekir-eli%C3%A7ora-a27b47392/"
        target="_blank"
        rel="noopener"
        aria-label="LinkedIn"
        class="icon"
      >
        <img
          class="base"
          src="assets/img/icons/social_media/linkedIn.svg"
          alt="LinkedIn"
        />
        <img
          class="hover"
          src="assets/img/icons/social_media/linkedIn_hover.svg"
          alt=""
          aria-hidden="true"
        />
      </a>
    </div>
  </nav>

  <div class="info-side">
    <p class="lead">{{ "contact.info.lead" | translate }}</p>
    <p class="muted">{{ "contact.info.muted" | translate }}</p>

    <div class="mobile_contacts">
      <ul class="contacts">
        <li>
          <div class="email-container">
            <img
              class="emailImg"
              src="assets/img/icons/contact/eMail_contact.svg"
              alt="E-Mail Icon"
            />
            <a class="emailLink" href="mailto:ebubekir.elicora@gmx.de"
              >E-Mail: ebubekir.elicora&#64;gmx.de</a
            >
          </div>
        </li>
        <li>
          <div class="phone-container">
            <img
              class="phoneImg"
              src="assets/img/icons/contact/phone_contact.svg"
              alt="Telefon Icon"
            />
            <a class="phoneLink" href="tel:+491714155340">Tel: 0171 4155340 </a>
          </div>
        </li>
      </ul>

      <div class="container-legal-notice">
        <div class="legal-notice-pos">
          <a class="legal-a" routerLink="/legal">{{
            "contact.footer.legal" | translate
          }}</a>
          <a class="policy-a" routerLink="/privacy">{{
            "contact.footer.policy" | translate
          }}</a>
          <p>&copy; Ebubekir Elicora 2025</p>
        </div>
      </div>
    </div>
  </div>

  <img
    class="next-arrow"
    src="assets/img/icons/arrows/arrow_left.png"
    alt="Zurück"
    role="button"
    tabindex="0"
    (click)="onBack()"
    (keydown.enter)="onBack()"
    (keydown.space)="onBack()"
  />

  <div class="contact-accent-layer">
    <div class="accent-bar" aria-hidden="true"></div>
  </div>
  <div class="contact-overlay" *ngIf="success || error">
    <div class="contact-overlay__backdrop"></div>
    <div
      class="contact-overlay__card"
      [ngClass]="{ 'contact-overlay__card--error': error }"
    >
      <p class="contact-overlay__title">
        <ng-container *ngIf="success && !error">
          {{ "contact.form.success" | translate }}
        </ng-container>
        <ng-container *ngIf="error">
          {{ "contact.form.error" | translate }}
        </ng-container>
      </p>
    </div>
  </div>
</section>

<section class="container-legal-notice mobile-legal">
  <div class="brand">
    <a
      class="brand-hit nav-link"
      href="#about"
      [attr.aria-label]="'nav.brand_about_aria' | translate"
    ></a>
    <svg
      class="brand-arc"
      viewBox="0 0 160 110"
      width="140"
      height="110"
      aria-hidden="true"
    >
      <path id="brandArcPath" d="M 20 90 A 62 100 0 0 1 140 90" fill="none" />
      <text class="brand-arc-text">
        <textPath
          href="#brandArcPath"
          startOffset="50%"
          text-anchor="middle"
          letter-spacing="-1"
        >
          {{ "nav.brand_arc" | translate }}
        </textPath>
      </text>
    </svg>
    <h1>EE</h1>
  </div>

  <div class="legal-notice-pos">
    <p>&copy;Ebubekir Elicora 2025</p>
    <div class="legal-policy-mobile-container">
      <a class="legal-a" routerLink="/legal">{{
        "contact.footer.legal" | translate
      }}</a>
      <a class="policy-a" routerLink="/privacy">{{
        "contact.footer.policy" | translate
      }}</a>
    </div>
  </div>
</section>
